import { createContext } from 'react';

export const MondayContext = createContext(null);